import { FC, memo } from 'react'
import {
  CrewTab,
  CrewTabProps,
} from 'components/elements/crewTabs/components/crewTab'

type Props = {
  tabItems: CrewTabProps[]
}
export const CrewTabs: FC<Props> = memo((props) => {
  return (
    <div className="flex flex-row flex-none h-10 items-center border-b crew-border-gray">
      {/* tabItem分だけ表示する */}
      {props.tabItems.map((item) => (
        <CrewTab
          text={item.text}
          selected={item.selected}
          onClick={item.onClick}
          // Warning表示回避のkey指定
          key={item.text}
          icon={item.icon}
          badgeCount={item.badgeCount}
          badgeColor={item.badgeColor}
        />
      ))}
    </div>
  )
})
